import '../ChangeRequestComment/comments.scss';

import isEmpty from 'lodash/isEmpty';
import React from 'react';
import Moment from 'react-moment';
import { Badge, Card, CardBody, Label } from 'reactstrap';

import CategorySelect from '../../generic/CategorySelect';
import CurrencyFormat from '../../generic/CurrencyFormat';
import { campaignLineShape } from '../../prop-types';
import { UI_DATE_FORMAT } from '../../utils/constants';
import NewDraftCampaignLineTextCopy from './NewDraftCampaignLineTextCopy';

function NewDraftCampaignLine({ line }) {
  const { product } = line;

  return (
    <Card className="c-comment__campaignline_card mb-2">
      <CardBody className="p-1">
        <Badge color="light" pill name="country">
          {line.country.name}
        </Badge>
        <CurrencyFormat
          value={line.spendableBudget}
          className="text-nowrap d-block"
          text
        />
        {product.overwriteTimeRange && (
          <Badge color="light" name="dates">
            <Moment format="DD.MM">{line.startDate}</Moment> -{' '}
            <Moment format="DD.MM">{line.endDate}</Moment>
          </Badge>
        )}
        {product.overwriteGender && (
          <Badge color="light" name="gender">
            {line.gender}
          </Badge>
        )}

        <div className="c-comment__field-label text-mute">
          <Moment fromNow titleFormat={UI_DATE_FORMAT} className="mr-2">
            {line.startDate}
          </Moment>
        </div>
        {product.overwriteCategories && !isEmpty(line.categories) && (
          <div className="small mt-1">
            <CategorySelect value={line.categories} />
          </div>
        )}
        <hr className="mb-0" />
        <Label className="c-comment__field-label"> Content Copy </Label>
        <NewDraftCampaignLineTextCopy line={line} />
        {product.serviceDescription && (
          <p className="c-comment__field-desc"> {line.desc1} </p>
        )}
      </CardBody>
    </Card>
  );
}

NewDraftCampaignLine.propTypes = {
  line: campaignLineShape.isRequired,
};

export default NewDraftCampaignLine;
